import phaseCodeService from "@services/phaseCode/phaseCodeService"
import { action, makeAutoObservable, observable } from "mobx"
import type { PagedResultDto } from "@services/dto/pagedResultDto"

class PhaseCodeStore {
  @observable isLoading!: boolean
  @observable listDataGetAll!: any[]
  @observable listDataChildGetAll!: any[]
  @observable detailData!: any
  @observable tableData!: PagedResultDto<any>

  @observable listPhaseCodeChild!: any[]
  constructor() {
    makeAutoObservable(this)

    this.listDataGetAll = []
    this.listDataChildGetAll = []
    this.tableData = { items: [], totalCount: 0 }
    this.listPhaseCodeChild = []
  }

  @action
  async createOrUpdate(body: any) {
    this.isLoading = true
    const result = await phaseCodeService.createOrUpdate(body).finally(() => {
      this.isLoading = false
    })

    this.detailData = result
  }
  @action
  async initDetail() {
    this.detailData = {}
  }

  @action
  async get(id: number) {
    const result = await phaseCodeService.get(id)
    this.detailData = result
    return result
  }

  @action
  async getAll(params: any) {
    this.isLoading = true
    const result = await phaseCodeService
      .getAll(params)
      .finally(() => (this.isLoading = false))

    this.listDataGetAll = result?.items ?? []
  }

  @action
  async getAllWithPagination(params: any) {
    this.isLoading = true
    const result = await phaseCodeService
      .getAll(params)
      .finally(() => (this.isLoading = false))

    // Handle both array and paginated object responses
    if (Array.isArray(result)) {
      this.tableData = { items: result, totalCount: result.length }
    } else {
      this.tableData = result
    }
  }

  @action
  async getAllChild(params: any) {
    this.isLoading = true
    const result = await phaseCodeService
      .getAllChild(params)
      .finally(() => (this.isLoading = false))
    this.listDataChildGetAll = result
  }

  @action
  async getListChild(params?: any) {
    this.isLoading = true
    const result = await phaseCodeService
      .getListChild(params)
      .finally(() => (this.isLoading = false))

    this.listPhaseCodeChild = result
  }

  @action
  async activateOrDeactivate(id: number, isActive) {
    await phaseCodeService.activateOrDeactivate(id, isActive)
  }
}

export default PhaseCodeStore
